
define('text!libs/strand/src/shared/js/es6-promise.html',[],function () { return '<script src="../../../bower_components/es6-promise/es6-promise.min.js"></script>\n';});

